export default "__VITE_ASSET__da0c3be2__"